<template>
    <div v-if="!hideBox" id="BorlabsCookieBox" class="BorlabsCookie relative z-50" role="dialog" aria-labelledby="CookieBoxTextHeadline" aria-describedby="CookieBoxTextDescription" aria-modal="true">
        <div class="middle-center _brlbs-block-content _brlbs-bg-animation show-cookie-box _brlbs-bg-dark" style="">
            <div class="_brlbs-box-wrap" style="width: 100vw; max-width: 550px;">
                <div class="_brlbs-box _brlbs-box-advanced _brlbs-animated _brlbs-fadeInDown">
                    <div class="cookie-box" aria-hidden="false">
                        <div class="container" style="opacity: 1;">
                            <div class="row">
                                <div class="col-12">
                                    <div class="_brlbs-flex-center">
                                        <img width="32" height="32" class="cookie-logo" src="images/siegel_recycling.png" alt="Datenschutzeinstellungen" aria-hidden="true"><span role="heading" aria-level="3" class="_brlbs-h3" id="CookieBoxTextHeadline">Datenschutzeinstellungen</span>
                                    </div>
                                    <p id="CookieBoxTextDescription"><span class="_brlbs-paragraph _brlbs-text-description">Wir benötigen Ihre Zustimmung, bevor Sie unsere Website weiter besuchen können.</span><span class="_brlbs-paragraph _brlbs-text-technology">Wir verwenden Cookies und andere Technologien auf unserer Website. Einige von ihnen sind essenziell, während andere uns helfen, diese Website und Ihre Erfahrung zu verbessern.</span><span class="_brlbs-paragraph _brlbs-text-personal-data">Personenbezogene Daten können verarbeitet werden (z. B. IP-Adressen), z. B. für personalisierte Anzeigen und Inhalte oder Anzeigen- und Inhaltsmessung.</span><span class="_brlbs-paragraph _brlbs-text-more-information">Weitere Informationen über die Verwendung Ihrer Daten finden Sie in unserer  <a class="_brlbs-cursor" :href="wordpressUrl + 'datenschutz/'">Datenschutzerklärung</a>.</span>
                                    </p>
                                    <fieldset>
                                        <legend class="sr-only">Datenschutzeinstellungen!!</legend>

                                        <ul>
                                            <li><label class="_brlbs-checkbox">
                                                Essenziell
                                                <input id="checkbox-essential" tabindex="0" type="checkbox" name="cookieGroup[]" value="essential" checked="" disabled="" data-borlabs-cookie-checkbox=""><span class="_brlbs-checkbox-indicator"></span></label>
                                            </li>
                                            <li><label class="_brlbs-checkbox">
                                                Externe Medien
                                                <input id="checkbox-external-media" tabindex="0" type="checkbox" name="cookieGroup[]" value="external-media" checked="" v-model="checkedExtern" data-borlabs-cookie-checkbox=""><span class="_brlbs-checkbox-indicator"></span></label>
                                            </li>
                                        </ul>
                                    </fieldset>
                                    <p class="_brlbs-accept">
                                        <a @click="setAccept(2)" tabindex="0" role="button" class="_brlbs-btn _brlbs-btn-accept-all _brlbs-cursor" data-cookie-accept-all="">
                                            Alle akzeptieren </a></p>
                                    <p class="_brlbs-accept">
                                        <a @click="setAccept()" tabindex="0" role="button" id="CookieBoxSaveButton" class="_brlbs-btn _brlbs-cursor" data-cookie-accept="">
                                            Speichern </a></p>
                                    <p class="_brlbs-refuse-btn">
                                        <a class="_brlbs-btn _brlbs-cursor" @click="setAccept(1)" tabindex="0" role="button" data-cookie-refuse="">
                                            Nur essenzielle Cookies akzeptieren </a></p>
                                    </div>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
        </div>
    </div>

</template>

<script>
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";

export default {
    setup() {
        const store = useStore();
        const getAccepted = computed(() => store.getters['Cookie/getAccepted'])

        const checkedExtern = ref(false);
        const hideBox = ref(false);

        const setAccept = (value) => {

            let storageValue = 1;
            if (value) {
                storageValue = value;
            } else if(!value && checkedExtern.value){
                storageValue = 2;
            }

            const blContent = document.querySelector('._brlbs-block-content');
            const blBox = blContent.querySelector('._brlbs-box');

            blContent.classList.remove('_brlbs-bg-dark');

            blBox.classList.add('_brlbs-flipOutX');
            setTimeout(() => {
                hideBox.value = true
            }, 1000)

            store.dispatch('Cookie/setAccept', storageValue);
            initGTwithParams();
        }

        const initGTwithParams = () => {
            if (getAccepted.value == 2) {
                initGT(window, document, 'script', 'dataLayer', 'GTM-KK97C99');
            }
        }


        onMounted(() => {

            if (getAccepted.value) {
                hideBox.value = true;
                checkedExtern.value = getAccepted.value;
            }

            initGTwithParams();

        })

        const initGT = (w,d,s,l,i) => {
            console.log('initGT');
            w[l]=w[l]||[];
            w[l].push(
                {
                    'gtm.start': new Date().getTime(),
                    event:'gtm.js'
                }
            );
            var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        }

        const wordpressUrl = window.CMS_URL;

        return {
            getAccepted,
            setAccept,
            checkedExtern,
            hideBox,
            wordpressUrl
        }
    }
}
</script>

<style scoped>

</style>
